module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Nearby Places (" + _vm._s(_vm.places.results && _vm.places.results.length ? _vm.places.results.length : 0) + ")")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 88,
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": _vm.pl,
      "content": "Select points of intrest"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "Select POI"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.poiSelect), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.label))])])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "align": "center"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": _vm.pl,
      "content": "Select range in m. to search"
    }
  }, [_c('el-slider', {
    attrs: {
      "min": 500,
      "max": 2000,
      "step": 25,
      "show-stops": "",
      "show-input": ""
    },
    model: {
      value: (_vm.mRadius),
      callback: function($$v) {
        _vm.mRadius = $$v
      },
      expression: "mRadius"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.places.results,
      "height": "50vh",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "fixed": "",
      "swidth": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('b', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vicinity",
      "label": "Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rating",
      "label": "Rating"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-rate', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.rating),
            callback: function($$v) {
              _vm.$set(scope.row, "rating", $$v)
            },
            expression: "scope.row.rating"
          }
        }), _vm._v(" "), (scope.row.user_ratings_total) ? _c('small', [_vm._v("Total Ratings: "), _c('b', [_vm._v("(" + _vm._s(_vm.formatInteger(scope.row.user_ratings_total)) + ")")])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "types",
      "label": "Type"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-367bfb3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/maps/NearbyPlaces.vue
// module id = 1417
// module chunks = 0